import React, { useState } from 'react';
import { Box, Button, Text } from 'grommet';
import LeagueScoreboard from './LeagueScoreboard'; // Matchup-based scoreboard
import LeagueScoreboardByScore from './LeagueHighScoreBoard';
import useLiveRefresh from '../useLiveRefresh';

const ToggleableLeagueScoreboard = ({ leagueId, season }) => {
  // State to toggle between scoreboards
  const [showOverallScore, setShowOverallScore] = useState(true);
  const { refreshKey, isLive, proGames } = useLiveRefresh(season);

  // Toggle function
  const toggleScoreboard = () => {
    setShowOverallScore(prevState => !prevState);
  };

  return (
    <Box pad="medium" flex={false}>
      <Text size="large" weight="bold" margin={{ bottom: 'small' }}>
        {showOverallScore ? 'Overall Score Leaderboard' : 'Matchup Scoreboard'}
      </Text>
      {isLive && (
        <Text size="small" color="status-critical" margin={{ bottom: 'small' }}>
          ● Live: scores update every 30 seconds
        </Text>
      )}

      {/* Toggle Button */}
      <Box flex={false} margin={{ bottom: 'medium' }}>
        <Button
          label={showOverallScore ? 'Switch to Matchups' : 'Switch to Overall Scores'}
          onClick={toggleScoreboard}
        />
      </Box>

      {/* Conditionally Render the Scoreboards */}
      {showOverallScore ? (
        <LeagueScoreboardByScore leagueId={leagueId} season={season} refreshKey={refreshKey} proGames={proGames} />
      ) : (
        <LeagueScoreboard leagueId={leagueId} season={season} refreshKey={refreshKey} />
      )}
    </Box>
  );
};

export default ToggleableLeagueScoreboard;